import { FILTER_TYPE } from '@intelligence/v3/filterControls/filterTypes';

import { PAGE_ID } from '../constants';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

export const ROBLOX_DEVICE_ALL_VALUE = 'ALL Device';

export const formatRobloxDeviceDownloadLabel = (
  device: string | undefined,
): string => {
  if (!device) {
    return '';
  }

  if (device === ROBLOX_DEVICE_ALL_VALUE) {
    return 'All Device';
  }

  return device;
};

export const ROBLOX_DEVICE_SELECT_OPTIONS = [
  { value: 'ALL Device', text: 'dbi_roblox_device_option_all' },
  { value: 'Entry-level Phone', text: 'dbi_roblox_device_option_entry_level_phone' },
  { value: 'Standard Phone', text: 'dbi_roblox_device_option_standard_phone' },
  { value: 'Entry-level Tablet', text: 'dbi_roblox_device_option_entry_level_tablet' },
  { value: 'Standard Tablet', text: 'dbi_roblox_device_option_standard_tablet' },
  { value: 'Computer', text: 'dbi_roblox_device_option_computer' },
  { value: 'Console', text: 'dbi_roblox_device_option_console' },
  { value: 'VR', text: 'dbi_roblox_device_option_vr' },
];

export const getRobloxDefaultDeviceValue = (): string[] => [ROBLOX_DEVICE_ALL_VALUE];

export const getRobloxDeviceFilterItem = (): IFilterItemConfig => ({
  type: FILTER_TYPE.TAG_SELECT,
  field: 'device',
  label: 'dbi_roblox_device',
  controlProps: {
    options: ROBLOX_DEVICE_SELECT_OPTIONS,
    title: 'dbi_roblox_device',
    singleSelect: true,
    searchable: true,
  },
  inherit: [PAGE_ID],
});
